import Debugger from './Debugger';
import Preview from './Preview';
import Swatches from './Swatches';
import Palette from './Palette';

export {
  Debugger, Preview, Swatches, Palette
};

export default {
  'debugger': Debugger,
  'preview': Preview,
  'swatches': Swatches,
  'palette': Palette
};
